import { API } from '@/api';
import axios from 'axios';

const state = {
};

const getters = {
};

const actions = {
  async getBorradoresList({ commit, State }, {condo, admin, options}) {
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    const response = await API.get('/lotes/draft/list/' + admin.id + '/' + condo.id, {params: queryString});
    return response.data;
  },
  async addLoteBorradores({ commit, State }, {condo, admin, borradores}) {
    const response = await API.post('/lotes/draft/' + admin.id + '/' + condo.id, borradores);
    return response.data;
  },
  async addLoteRecibos({ commit, State }, {admin, condo, recibos}) {
    const response = await API.post('/lotes/add/' + admin.id + '/' + condo.id, recibos);
    return response.data;
  },
};

const mutations = {
};

export default {
  actions,
  getters,
  mutations,
  state,
};
